import { render, staticRenderFns } from "./RPlist.vue?vue&type=template&id=060b4bb8&scoped=true"
import script from "./RPlist.vue?vue&type=script&lang=js"
export * from "./RPlist.vue?vue&type=script&lang=js"
import style0 from "./RPlist.vue?vue&type=style&index=0&id=060b4bb8&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060b4bb8",
  null
  
)

export default component.exports